/**
 * Applications source names values used when geting values from raw sql query.
 */

export enum ApplicationSourceNameValueEnum {
  JUST_EAT = 'JUST_EAT',
  DELIVEROO = 'DELIVEROO',
  CARD_ONLINE = 'CARD_ONLINE'
}
